// extracted by mini-css-extract-plugin
export var subtitle = "SectionTitle-module__subtitle___No0iB";
export var title = "SectionTitle-module__title___XKIeu";